import jwt_decode from "jwt-decode";
import { _getRouteToRender } from "../../app/getRouteToRender"
import { PARTICIPANT_ROLE } from "../../base/participants";
import { FEATURE_CUSTOM_REDUX } from "../constant";
import { setAuthVerify } from "../redux/tool-webjam/actions";
import { AUTH_TOKEN, dispatch, getBaseConfig, getQueryString, getStore } from "../Utils";
import { getOrganizationList, getOrganizationListAuth, validateAuthToken } from "../welcome-dashboard/Request.d";
import { CURRENT_ROOM_NAME } from "../../webjam/constant";


let decoded;
let token = "";

export const removeTokenSession = (type) => {
    // if (sessionStorage.getItem("foundToken")) {
    //     sessionStorage.setItem("_at", sessionStorage.getItem("foundToken"))
    //     sessionStorage.removeItem("foundToken")
    // }
}


export async function getJwtUrl() {
    let room = CURRENT_ROOM_NAME;


    let querystring = window.location.search.substring(1);
    if (querystring) {
        let getToken = getQueryString(AUTH_TOKEN)
        if (getToken && getToken != undefined) {
            token = getToken;
            sessionStorage.setItem("foundToken", token);
        }
    }

    const { iAmRecorder } = getStore("features/base/config");

    if ((window.location.hash.indexOf("config.iAmRecorder") != -1 || window.location.hash.indexOf("AUDIO_GHOST") != -1) || iAmRecorder) {
        setTimeout(function () {
            dispatch(setAuthVerify({
                status: true,
                type: "join"
            }))
        }, 3000)
    } else {
        // TO MAINTAIN CURRENT USER SESSION
        if (sessionStorage.getItem("foundToken")) {
            token = sessionStorage.getItem("foundToken");
        }
        if (room == undefined) {
            removeTokenSession(1)
            dispatch(setAuthVerify({
                status: false,
                type: "leave"
            }))
        } else if (token == '' || token == undefined) {
            removeTokenSession(2)

            dispatch(setAuthVerify({
                status: false,
                type: "leave"
            }))
        } else {
            try {
                decoded = jwt_decode(token);
                if (decoded?.room == room) {
                    const { organizationList } = getStore(FEATURE_CUSTOM_REDUX);
                    // console.log("ggggggggggggggggggggggg ", organizationList)
                    await dispatch(getOrganizationListAuth(token, decoded))
                } else {
                    removeTokenSession(3)

                    dispatch(setAuthVerify({
                        status: false,
                        type: "leave"
                    }))
                }
            } catch (e) {
                removeTokenSession(4)

                dispatch(setAuthVerify({
                    status: false,
                    type: "leave"
                }))
                console.log("token parse error ", e)
            }
        }
    }
}

export const updatedToolBar = (filtered, sliceIndex, buttons) => {
    var disabledButtons = ["embedmeeting"];
    const { tokenDecodedData, secondModerator } = getStore(FEATURE_CUSTOM_REDUX);

    const { local } = getStore('features/base/participants')

    let willSecurity = true;

    if (tokenDecodedData) {
        if (!tokenDecodedData.teacher) {
            willSecurity = false;
            disabledButtons.push("security");
        }
    }

    if (local.role == PARTICIPANT_ROLE.MODERATOR) {
        disabledButtons.push("security");
    }

    if (tokenDecodedData) {
        if (tokenDecodedData.student && !secondModerator) {
            disabledButtons.push("desktop");
            willSecurity = false;
        }
    }

    if (tokenDecodedData) {
        if (tokenDecodedData.hasOwnProperty("gm")) {
            if (tokenDecodedData.gm) {
                willSecurity = true;
                let secIndex = disabledButtons.indexOf("security");
                if (secIndex != -1) {
                    disabledButtons.splice(secIndex, 1)
                }
            }
        }
    }

    let mainManuBtn = filtered.slice(0, sliceIndex);
    // These are coming are main menu so removing them
    mainManuBtn = mainManuBtn.filter((k, v) => {
        return k.key !== "profile" && k.key != "videoquality" && !disabledButtons.includes(k.key)
    })

    let overflowMenuButtons = filtered.slice(sliceIndex);

    let _overflowMenuButtons = overflowMenuButtons;

    if (!willSecurity) {
        _overflowMenuButtons = _overflowMenuButtons.filter((k, v) => {
            return k.key != "security" && k.key != "embedmeeting" && k.key != "shareaudio";
        })
    }

    let buttonKeys = _overflowMenuButtons.map(e => e.key);

    // Some time the main menu and sub menu(vertical menu) items are not in arrangement or showing displacement
    // FIX ME->currently profile is not coming while making conference with token in student side
    // if showing duplicate then remove below code

    if (tokenDecodedData) {
        // For videoquality to add
        if (buttonKeys.indexOf("videoquality") == -1) {
            _overflowMenuButtons.unshift(buttons.videoQuality);
        }

        for (let i = 0; i < overflowMenuButtons.length; i++) { // For profile to add
            if (overflowMenuButtons[i].key != "profile") {
                _overflowMenuButtons.unshift(buttons.profile);
                break;
            }
        }
    }

    return {
        mainMenuButtons: mainManuBtn,
        overflowMenuButtons: _overflowMenuButtons
    };

}

export function createCookie(name, value) {
    var date = new Date();
    date.setTime(date.getTime() + (30 * 1000));
    var expires = "; expires=" + date.toGMTString();
    document.cookie = name + "=" + value + expires + "; path=/";
}

export function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}